export default __webpack_public_path__ + "static/driver-home-cc7bc091a7d3092f2e65e266b67b2dd1.png";